// extracted by mini-css-extract-plugin
export default {"firstBlock":"kuzIfpv0","glavnoe":"V1cquCBM","news":"q1ijf3ZB","link":"wZdNEYVH"};